/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {
	ActionTypes,
	resetPasswordSceneAccountNameInputChanged,
	resetPasswordSceneAccountNameSubmitted,
	resetPasswordSceneAccountRecoveryUnexpectedError,
	resetPasswordSceneActivated,
	resetPasswordSceneRecoveryStarted,
	resetPasswordSceneStartAccountRecoveryValidationException
} from './actions';
import {getType} from 'typesafe-actions';
import {ConstraintViolationDTO} from '../../model/validation';

export interface ResetPasswordState {
	message: string;
	submitDisabled: boolean;
	violations: { [key: string]: ConstraintViolationDTO[] };
}

const initialState: ResetPasswordState = {
	message: 'Vul hier uw e-mailadres in, zodat we u instructies kunnen sturen om een nieuw wachtwoord in te stellen.',
	submitDisabled: false,
	violations: {}
};

const reducer = (state: ResetPasswordState = initialState, action: ActionTypes): ResetPasswordState => {
	switch (action.type) {
		case getType(resetPasswordSceneActivated):
			return initialState;
		case getType(resetPasswordSceneAccountNameInputChanged):
			return {...state, violations: {...state.violations, accountName: []}};
		case getType(resetPasswordSceneAccountNameSubmitted):
			return {...state, submitDisabled: true};
		case getType(resetPasswordSceneAccountRecoveryUnexpectedError):
			return {...state, submitDisabled: false};
		case getType(resetPasswordSceneStartAccountRecoveryValidationException):
			return {...state, violations: action.payload.violations, submitDisabled: false};
		case getType(resetPasswordSceneRecoveryStarted):
			return {...state, message: 'We hebben een e-mail gestuurd, met daarin instructies om het wachtwoord opnieuw in te stellen.'};
		default:
			return state;
	}
};

export default reducer;
